/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onActionClosePopover = useDataOnActionClosePopover(props, data)

  return async function onSubmit({ value, change, args }) {
    switch (args?.type) {
      case 'close_popover': {
        return onActionClosePopover()
      }
      default: {
      }
    }
  }
}

/** @type {import('Simple/type.js').useDataOnSubmit} */
function useDataOnActionClosePopover(props) {
  return async function onAction() {
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
